import { Card, Col, Container, Image, ListGroup, ListGroupItem, Row } from "react-bootstrap";

import { Link } from "react-router-dom";
import classes from '../HeadingComponent.module.css';

function ArchiveContent() {
  return (
  <Container fluid className={classes.container}>
    <div className={classes.headingCard}><a href="/">archive</a></div>
    <Container>
      <div class="row mt-5">
         <div className="">
            <span className="fs-4 text-center">
               <h1>y e a r</h1>
            </span>
            <hr class="mb-4">
            </hr>
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1769029899/Lawan-blog/archive/2023/2023-10-21_a_xed8qx.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2023" className="text-center">2023</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1769018995/Lawan-blog/archive/2022/2022-10-11_a_nxcodc.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2022" className="text-center">2022</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1768932716/Lawan-blog/archive/2021/2021-09-04_ukm6l7.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2021" className="text-center">2021</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1768860496/Lawan-blog/archive/2020/2020-07-22_d7vbsl.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2020" className="text-center">2020</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1768677796/Lawan-blog/archive/2019/2019-11-10_c_lkkyld.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2019" className="text-center">2019</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1754621189/Lawan-blog/archive/2018/2018-08-11_C959050A_u9tmbe.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2018" className="text-center">2018</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753892671/Lawan-blog/archive/2016/2016-08-18_cwsroc.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2016" className="text-center">2016</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753892692/Lawan-blog/archive/2015/2015-08-05_1280_mjd1to.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2015" className="text-center">2015</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
            {/* R O W ONE */}
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753894803/Lawan-blog/archive/2014/2014_wnt/2014-12-10_02_sgybq4.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2014_wnt" className="text-center">fall - winter 2014</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753894853/Lawan-blog/archive/2014/2014_smm_fll/2014-09-14_02_npqnld.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2014_smm_fll" className="text-center">spring - summer 2014</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753894900/Lawan-blog/archive/2014/2014_wnt_spr/2014-01-29_01_mxrwdx.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2014_wnt_spr" className="text-center">winter - spring 2014</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753896560/Lawan-blog/archive/2013/2013_wnt/2013-11-12_01_cizwnn.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2013_wnt" className="text-center">fall - winter 2013</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
            {/* R O W TWO */}
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753896613/Lawan-blog/archive/2013/2013_smm/2013-06-27_wlo2dg.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2013_smm" className="text-center">summer 2013</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753896654/Lawan-blog/archive/2013/2013_wnt_spr/2013-02-13_tdfaww.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2013_wnt_spr" className="text-center">winter - spring 2013</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img className="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753909138/Lawan-blog/archive/2012/2012_wnt/2012-10-16_ivl9vc.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2012_wnt" className="text-center">fall - winter 2012</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img className="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753909120/Lawan-blog/archive/2012/2012_smm/2012-08-04_pqmnmz.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2012_smm" className="text-center">summer 2012</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
            {/* R O W THREE */}
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753909216/Lawan-blog/archive/2012/2012_wnt_spr/2012-02-19_mc66tw.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2012_wnt_spr" className="text-center">winter - spring 2012</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753908801/Lawan-blog/archive/2011/2011_fll/2011-10-23_mpomgg.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2011_fll" className="text-center">fall - winter 2011</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753908792/Lawan-blog/archive/2011/2011_smm/2011-09-26_emih5x.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2011_smm" className="text-center">summer 2011</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img className="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753908887/Lawan-blog/archive/2011/2011_spr/2011-04-09_ck2ol0.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2011_spr" className="text-center">spring 2011</Link>
                  </Card.Text>
               </Card.Body>
               </Card> 
            </Row>
            {/* R O W FOUR */}
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img className="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753908952/Lawan-blog/archive/2011/2011_wnt/2011-03-21_njcaby.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2011_wnt" className="text-center">winter - spring 2011</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div className="overflow-hidden">
                  <Card.Img src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753903871/Lawan-blog/archive/2010/2010_fll/2010-11-06_n5xcst.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2010_fll" className="text-center">fall - winter 2010</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753903901/Lawan-blog/archive/2010/2010_smm/2010-08-25_02_jhn0bf.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2010_smm_sa" className="text-center">summer 2010, sept-aug</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753903940/Lawan-blog/archive/2010/2010_smm/2010-07-16_nltehk.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2010_smm_jj" className="text-center">summer 2010, july-jun</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
            {/* R O W FIVE*/}
            <Row className="d-flex justify-content-center" lg={3}>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753903947/Lawan-blog/archive/2010/2010_spr/2010-03-05_s7vg4x.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2010_spr" className="text-center">spring 2010</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753903918/Lawan-blog/archive/2010/2010_wnt/2010-02-25_lbbouh.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2010_wnt" className="text-center">winter 2010</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753896854/Lawan-blog/archive/2009/2009_fll/2009-10-27_02_wteqqc.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2009_fll" className="text-center">fall - winter 2009</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
               <Card border="light" className="border-0" style={{ width: '15rem', height: '12rem' }}>
               <div class="overflow-hidden position-relative">
                  <Card.Img class="img-fluid" src="https://res.cloudinary.com/dkmfcd06l/image/upload/v1753897037/Lawan-blog/archive/2009/2009_smm/2009-07-16_qcbahq.jpg" />
               </div>
               <Card.Body>
                  <Card.Text className="text-center">
                    <Link to="archive/2009_smm" className="text-center">summer 2009</Link>
                  </Card.Text>
               </Card.Body>
               </Card>
            </Row>
         </div>
      </div>
    </Container>
  </Container>
  );
}

export default ArchiveContent;

